import { render, staticRenderFns } from "./NotebookEmbed.vue?vue&type=template&id=79baaf87&"
import script from "./NotebookEmbed.vue?vue&type=script&lang=js&"
export * from "./NotebookEmbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports